import Api from "./api.service";

const ENDPOINT = "cancellation-request";

export default {
  update: (lawyerId, data) => Api.patch(`${ENDPOINT}/${lawyerId}`, data),
  get: (params) => Api.get(`${ENDPOINT}`, { params }),
};
